import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Settings from './views/Settings.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        auth: {
          roles: 'super'
        }
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        auth: {
          roles: 'super'
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        auth: false
      }
    }
  ]
})
